module.exports = __webpack_public_path__ + "static/logo1-f282cd7294f2d59054a14dfd02ad8e43.png";